import { EnhancedOutgoingMessagesStatistic } from '@mm/state/model/ConnectedPageModel';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import { getPlanInfo } from '@mm/state/helpers/billing-info-helpers';

const upgradeNowText =
  'Upgrade now to continue to engage your contacts without interruption!';
const continueSendText = 'Upgrade now to continue sending messages';

export const getWarningText = (
  messagesStatistic: EnhancedOutgoingMessagesStatistic,
  facebookPage?: EnhancedBillingPage,
) => {
  const { utilizationPercentage, messagesRemaining } = messagesStatistic;
  const sendsLeftText = messagesRemaining === 1 ? 'send' : 'sends';
  const planInfo = getPlanInfo(facebookPage);

  const isFreeTrialPromotionWithoutSubscription =
    !!facebookPage?.redemption?.freeTrial && !facebookPage?.subscription;

  const billingPeriod = facebookPage?.subscription?.billingPeriodLength;
  const customPeriodLength = facebookPage?.subscription?.planIntervalLength;

  const period =
    billingPeriod === 'annually'
      ? 'yearly'
      : billingPeriod === 'monthly' && (customPeriodLength || 0) > 1
      ? `${customPeriodLength} months period`
      : 'monthly';

  if (planInfo.isAnyProPlan) {
    if (utilizationPercentage > 99) {
      return `
        has already used up ${utilizationPercentage}% of its ${period} send allotment. Automations have been shut down.
        ${continueSendText}
      `;
    }

    return `
      has already used up ${utilizationPercentage}% of its ${period} send allotment. You have ${messagesRemaining} more
      ${sendsLeftText} before the automations get shut down. ${continueSendText}
    `;
  }

  if (planInfo.isAnyTeamPlan) {
    if (utilizationPercentage > 99) {
      return `
        Your Agency subscription has already used up ${utilizationPercentage}% of its ${period} send
        allotment. Automations have been shut down. ${continueSendText}
      `;
    }

    return `
      Your Agency subscription has already used up ${utilizationPercentage}% of its ${period} credits limit.
      You have ${messagesRemaining} more sends before the automations shut down. ${continueSendText}
    `;
  }

  if (planInfo.isFreePlan || isFreeTrialPromotionWithoutSubscription) {
    if (utilizationPercentage > 99) {
      return `has already used up ${utilizationPercentage}% of its ${period} send allotment. ${upgradeNowText}`;
    }

    return `
      has already used up ${utilizationPercentage}% of its ${period} send allotment. You
      have ${messagesRemaining} more ${sendsLeftText} before the automations get shut down. ${upgradeNowText}
    `;
  }

  return '';
};
